<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="lr between">
          <div style="display: flex;justify-content: space-between;">
            <el-input v-model="table.query.keyWord" placeholder="请输入关键字查询" clearable
                      suffix-icon="el-icon-search" @change="search(true)"/>
          </div>
          <div style="display: flex;justify-content: flex-end;">
            <el-button type="primary" size="small" @click="openDialog(null, false)"
                       icon="el-icon-plus">新增
            </el-button>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="400px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="名称" align="center"
                             prop="name"></el-table-column>
<!--            <el-table-column show-overflow-tooltip label="费用" align="center"-->
<!--                             prop="fee"></el-table-column>-->
            <el-table-column show-overflow-tooltip label="备注" align="center"
                             prop="description"></el-table-column>
            <el-table-column show-overflow-tooltip label="排序值" align="center"
                             prop="sort"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="210" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="openDialog(scope.row, true)">编辑</el-button>
                <el-button type="text" style="color: #ff4949;" @click="deleteData(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="feeDialog.visible" :close-on-click-modal="false" width="40%" append-to-body
               :title="!isEdit ? '新增项目' : '编辑项目' + title">
      <el-form ref="feeForm" label-position="right" label-width="120px" :model="feeDialog.formData"
               :rules="rules">
        <el-form-item label="名称：" prop="name">
          <el-input placeholder="请输入名称" v-model="feeDialog.formData.name" clearable/>
        </el-form-item>
<!--        <el-form-item label="费用：" prop="agencyFee">-->
<!--          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%" v-model="feeDialog.formData.agencyFee"-->
<!--                           clearable/>-->
<!--        </el-form-item>-->
        <el-form-item label="备注：" prop="description">
          <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="feeDialog.formData.description"></el-input>
        </el-form-item>
        <el-form-item label="排序值：" prop="sort">
          <el-input-number style="width: 100%;" :min="0" :step="1" v-model="feeDialog.formData.sort"/>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="feeDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateData" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import {getPageList, deleteData, saveOrUpdateData} from "@/api/fee";

export default {
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          type: 4,
          keyWord: ''
        },
        total: 0,
        data: []
      },
      feeDialog: {
        formData: {
          houseId: '',
          houseName: '',
          rentRecordIds: '',
          rentRecordNames: '',
          name: '',
          agencyFee: 0,
          type: 4,
          description: '',
          sort: 0
        },
        visible: false
      },
      rules: {
        name: [
          {trigger: 'blur', required: true, message: '请输入名称'}
        ],
        agencyFee: [
          {trigger: 'blur', required: true, message: '请输入费用'}
        ],
        sort: [
          {trigger: 'blur', required: true, message: '请输入排序值'}
        ]
      },
      loading: false,
      tableLoading: false,
      isEdit: false
    }
  },
  mounted() {
    this.search(true)
  },
  methods: {
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
        this.table.query.keyWord = ''
        this.table.query.type = 4
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord,
        type: this.table.query.type
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 修改
    saveOrUpdateData() {
      this.loading = true
      this.$refs['feeForm'].validate(async (valid) => {
        if (valid) {
          saveOrUpdateData(this.feeDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.feeDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    // 打开弹窗
    openDialog(data, isEdit) {
      this.isEdit = isEdit
      if (!isEdit) {
        // 重置数据
        this.feeDialog.formData = {
          houseId: this.houseId,
          houseName: '',
          rentRecordIds: '',
          rentRecordNames: '',
          feeIds: '',
          feeNames: '',
          name: '',
          agencyFee: 0,
          type: 4,
          description: '',
          sort: 0
        }
      } else {
        this.feeDialog.formData = JSON.parse(JSON.stringify(data))
      }
      this.feeDialog.visible = true
      // 清空验证信息
      this.$nextTick(() => {
        this.$refs.feeForm.clearValidate()
      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    // 删除
    deleteData(id) {
      this.$confirm('此操作将永久删除' + this.title + '信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteData(id).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error(response.data)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/RenovationItem.vue